import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { HorizontalLine, VerticalLine } from '../../../../components/shapes/Line'
import FlexGrid from '../../../../components/structure/FlexGrid'
import LabelValueBox from '../../../../components/presentation/LabelValueBox'
import Separator from '../../../../components/helpers/Separator'
import { useSessionPermission } from '@btime/react-session'

const IndicatorsBoxes = ({ counters }) => {
  const { nonCompliancesCount, actionPlansCount, attendanceTime } = counters || {}
  const { t } = useTranslation('serviceOrders')
  const hideAttendanceTime = useSessionPermission('hideAttendanceTime')
  const commonProps = { t: v => t('fields.' + v) }

  return (
    <Fragment>
      <Separator weight={5} />
      <HorizontalLine thin lineColor={COLORS.light3} />
      <FlexGrid justify="stretch" align="stretch" wrap>
        <VerticalLine thin lineColor={COLORS.light3} width="1px" />
        <LabelValueBox label={t('indicators.nonCompliances')} value={nonCompliancesCount || 0} hideOn="mdd" />
        <VerticalLine thin lineColor={COLORS.light3} />
        <LabelValueBox label="actionPlans" value={actionPlansCount || 0} hideOn="mdd" {...commonProps} />
        <VerticalLine thin lineColor={COLORS.light3} />
        {!hideAttendanceTime && <LabelValueBox label="serviceTime" value={attendanceTime} {...commonProps} />}
      </FlexGrid>
    </Fragment>
  )
}

export default IndicatorsBoxes
